import publicReq, { privateReq, imageReq } from './axiosConfig';

export const getOrdersListService = (data) =>
    privateReq.get("/orders/orders-list" + data);

export const uploadReportService = (data) =>
    privateReq.post("/orders/upload-report", data);